export const BINDER_LIST_GET = "common/BinderList/BINDER_LIST_GET";
export const BINDER_ITEM_GET = "common/BinderList/BINDER_ITEM_GET";
export const CHECKED_TOGGLE = "common/BinderList/CHECKED_TOGGLE";
export const VS_BINDER_LIST_GET = "common/BinderList/VS_BINDER_LIST_GET";
export const VS_BINDER_ITEM_GET = "common/BinderList/VS_BINDER_ITEM_GET";
export const VS_CHECKED_TOGGLE = "common/BinderList/VS_CHECKED_TOGGLE";
export const CLEAR_CHECKED = "common/BinderList/CLEAR_CHECKED";
